// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"51cbbdf7","455":"b2936588","977":"5f93ed55"}[chunkId] + ".chunk.js";
};